import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IntTalentCaptureJobSearchSlot from './IntTalentCaptureJobSearchSlot';
import superagent from 'superagent';

export class ContextualContent extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { rz } = global.TES || {};
    const thunk = (rzParam) => rzParam.registerDynamicSection('rebrandJobs');
    if (rz) {
      thunk(rz);
    } else {
      global.document.addEventListener('rzReady', ({ detail: rzObj }) => {
        thunk(rzObj);
      });
    }

    const query = [
      'type=int-talent-capture',
      'context=jobs-search',
      'thinForm=true',
      'hideFromOptedInUsers=true',
      'hideWhenAllFieldsComplete=true',
      'title=Want to find the perfect job faster?',
      'introduction=Simply tell us a little more about your experience and what you’re looking for and we can contact you about jobs we think match your profile.'
    ].join('&');

    superagent(`/widget/int-talent-capture/lite?${query}`).then(response => this.setState({ tcWidgetContent: response.text }));
  }

  render() {
    const { searchType, isInternational } = this.props;

    return (
      <div>
        {isInternational && <IntTalentCaptureJobSearchSlot/>}
        {searchType !== 'supply' && <div className="text-left tc-widget-root" id="tes-tc-widget-custom" dangerouslySetInnerHTML={{__html: this.state.tcWidgetContent}}/>}
        {searchType !== 'supply' &&
        <div className="margin-bottom-md" data-rz="rebrandJobs"/>}
      </div>
    );
  }
}

ContextualContent.propTypes = {
  doubleMpu: PropTypes.array,
  searchType: PropTypes.array,
  isInternational: PropTypes.bool
};

